import React, { ReactNode } from 'react';
import { Modal, ModalProps } from 'antd';

interface CustomModalInfoProps extends ModalProps {
  title?: string;
  width?: string | number;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

const CustomModalInfo = ({
  title,
  width,
  open,
  onClose,
  children,
  ...props
}: CustomModalInfoProps) => (
  <Modal
    title={title}
    open={open}
    width={width}
    onCancel={onClose}
    bodyStyle={{ padding: 40 }}
    footer={false}
    destroyOnClose
    {...props}
  >
    {children}
  </Modal>
);

export default CustomModalInfo;
